import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { ClosedLargeIcon } from '../../../../Custom-imeges/ClosedLargeIcon';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../store/hooks';
import "../get-conversation/Popups.css";
import { GoPaymentArrowIcon } from '../../../../Custom-imeges/GoPaymentArrowIcon';
import { useEffect, useState } from 'react';
import { Opacity } from '@mui/icons-material';
import zIndex from '@mui/material/styles/zIndex';

interface CloseChatsModePopupProps {
  open: boolean;
  handleClose: () => void;
  handleOpen: () => void;
  showUpgradeToProModal: () => void;
  ContainerRef?: any;
}

const style = {
    position: 'absolute',
    height: 'calc(100% - 23px)',
    width: '98%',
    top: '7px',
    left: '1%',
    zIndex: 2,
    '& .MuiBackdrop-root': {
    position: 'absolute',
    borderRadius: '12px',
    opacity: "0.4 !important",
    boxShadow: `
        15.12px -15.12px 15.12px 0px rgba(33, 36, 40, 0.34) inset, 
        30.24px -30.24px 30.24px 0px rgba(255, 255, 255, 0.34) inset, 
        -15.12px 15.12px 15.12px 0px rgba(255, 255, 255, 0.34) inset, 
        -30.24px 30.24px 30.24px 0px rgba(33, 36, 40, 0.34) inset`,
    backdropFilter: 'blur(204.876px)',
    Opacity:0.4,
    },
    '@media (max-width: 900px)': {
        height: '97%',
        top: '12px',
    },
}

export const ClosedChatsModePopup = ({ open, handleClose ,handleOpen,showUpgradeToProModal ,ContainerRef }: CloseChatsModePopupProps) => {
    const navigate = useNavigate();
    const User = useAppSelector((s) => s.User);
    const ChatsStore = useAppSelector((s) => s.ChatsState);
    const [openModal, setOpenModal] = useState(false);

    useEffect(()=> {
        if(User.IsAuthenticated) {
            if(ChatsStore.chatsNum > 4 && !User.isSubscribed) {
                setOpenModal(true);
                handleOpen();
            } else {
                setOpenModal(false);
                handleClose();
            }
        } else if (!User.IsAuthenticated) {
            if(ChatsStore.chatsNum > 2) {
                setOpenModal(true);
                handleOpen();
            } else {
                setOpenModal(false);
                handleClose();
            }
        } else {
            setOpenModal(false);
            handleClose();
        }
    } ,[ChatsStore.chatsNum, ChatsStore.showPlansModal])

    const getMessage = () => {
        if (!User.IsAuthenticated) {
            return {
                title: "More Models, More Insights!",
                description: "Unlock the ability to connect with multiple AI models by signing in!",
                actionText: "Sign in for free",
                actionLink: () => navigate("/account/login"),
            };
        } else {
            return {
                title: "More Models, More Insights!",
                description: "Upgrade to premium and enjoy unlimited access to all AI models for a richer experience.",
                actionText: "Upgrade to Premium",
                actionLink: () => {
                  showUpgradeToProModal();
                },
            };
        }
    };

    const { title, description, actionText, actionLink } = getMessage();

    return (
        <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className='close-mode-modal'
        container={ContainerRef.current} sx={style}>
            <Box className="closed-modes-modal">
                <ClosedLargeIcon />
                <Typography className="modal-modal-title" variant="h6">
                    {title}
                </Typography>
                <Typography className="modal-modal-description">
                    {description}
                </Typography>
                <Box sx={{display:'flex',alignItems:'center',justifyContent:'center',gap:"1rem",cursor:'pointer'}} onClick={actionLink}>
                    <Typography className="modal-modal-link">
                        {actionText}
                    </Typography>
                    <GoPaymentArrowIcon/>
                </Box>
            </Box>
        </Modal>
  );
};
